import React from 'react'

const statuses = {
  info: { color: '#1ab394', class: 'fa fa-info-circle fa-1x' },
  warning: { color: '#f8ac59', class: 'fa fa-exclamation-triangle fa-1x' },
  critical: { color: '#f8ac59', class: 'fa fa-exclamation-triangle fa-1x' },
}

const ImportanceIcon = ({ status }) => {
  const state = statuses[status]
  if (state) {
    return <i title={status} style={{ color: state.color }} className={state.class} />
  }
  return null
}
export default ImportanceIcon
